/**
 * Layout wrapper for all /settings/* routes — single AppRoute guard.
 */

import { Outlet } from 'react-router-dom'
import { AppRoute } from '@/components/routing/AppRoute'

export function SettingsRouteLayout() {
  return (
    <AppRoute routeId="settings">
      <Outlet />
    </AppRoute>
  )
}
